// Import the languages and language workers we want.
import editorWorker from 'monaco-editor/esm/vs/editor/editor.worker?worker&url'
import jsonWorker from 'monaco-editor/esm/vs/language/json/json.worker?worker&url'
import tsWorker from 'monaco-editor/esm/vs/language/typescript/ts.worker?worker&url'

// Import monaco
import * as monaco from 'monaco-editor'

// Do ybsql language setup.
import register from './lang/ybsql'

export const getWorkerUrl = (label) => {
  if (label === 'json') {
    return jsonWorker
  }
  if (label === 'typescript' || label === 'javascript') {
    return tsWorker
  }
  return editorWorker
}

// Do web worker setup.
self.MonacoEnvironment = {
  getWorker(_, label) {
    const workerUrl = getWorkerUrl(label)
    const js = `import ${JSON.stringify(workerUrl)}`
    const blob = new Blob([js], { type: 'application/javascript' })
    const objURL = URL.createObjectURL(blob)
    return new Worker(objURL, { type: 'module', name: label })
  }
}

monaco.languages.typescript.javascriptDefaults.setDiagnosticsOptions({
  noSemanticValidation: false,
  noSyntaxValidation: false
})

// compiler options
monaco.languages.typescript.javascriptDefaults.setCompilerOptions({
  noLib: true,
  target: monaco.languages.typescript.ScriptTarget.ES5,
  allowNonTsExtensions: true
})

// Export monaco for outside use.
export default monaco

// Export our api.
export * from './api'

// Setup ybsql.
register(monaco)
